module.exports = __webpack_public_path__ + "static/logo-pko-fintech-a8d9b73de008f66f4cedb44543cd841a.svg";